<ng-container *ngIf="!includesAddress;else addressForm">
  <div class="manufacturers-container">
    <div class="manufacturers-item-container">
      <div class="manufacturers-item-input-container">
        <mat-form-field appearance="outline" class="manufacturers-form-field">
          <mat-label *ngIf="formType!='FormC'">Manufacturer(s)</mat-label>
          <mat-label *ngIf="formType ==='FormC'">Manufacturer(s) Name & Address</mat-label>
          <input matInput #manufacturersInput [(ngModel)]="manufacturers" class="manufacturers manufacturers-item-input"
            (keyup.enter)="updateManufacturers($event)" (keyup.escape)="cancelManufacturersUpdate()" (blur)="updateManufacturers($event)" />
          <mat-icon matSuffix (mousedown)="clearManufacturersInputField()">cancel</mat-icon>
        </mat-form-field>
      </div>
      <div class="input-error" *ngIf="hasFieldValidationError('manufacturers')">
        This is a required field.
      </div>
    </div>
    <div class="manufacturers-info manufacturers-info-text">
      Please list the company sponsoring development of the drug in the US.
    </div>
  </div>
</ng-container>
<ng-template #addressForm>
  <div class="manufacturers-container">
    <span class="phase-one-trial-date-text">Name and Address of Manufacturer</span>
    
    <div class="manufacturers-item-container">
      <div class="manufacturers-item-input-container">
        <mat-form-field appearance="outline" class="manufacturers-form-field">
          <mat-label>Name</mat-label>
          <input matInput #nameInput [(ngModel)]="manufacturerInfo.name" class="manufacturers manufacturers-item-input"
            (keyup.enter)="updateName()" (keyup.escape)="cancelNameUpdate()" (blur)="updateName($event)" />
          <mat-icon matSuffix (mousedown)="clearNameInputField()">cancel</mat-icon>
        </mat-form-field>
      </div>
    </div>
    
    <div class="manufacturers-item-container">
      <div class="manufacturers-item-input-container">
        <mat-form-field appearance="outline" class="manufacturers-form-field">
          <mat-label>Address</mat-label>
          <input matInput #street1Input [(ngModel)]="manufacturerInfo.street1" class="manufacturers manufacturers-item-input"
            (keyup.enter)="updateStreet1()" (keyup.escape)="cancelStreet1Update()" (blur)="updateStreet1($event)" />
          <mat-icon matSuffix (mousedown)="clearStreet1InputField()">cancel</mat-icon>
        </mat-form-field>
      </div>
    </div>
    
    <div class="manufacturers-item-container">
      <div class="manufacturers-item-input-container">
        <mat-form-field appearance="outline" class="manufacturers-form-field">
          <mat-label>Address 2 (Optional)</mat-label>
          <input matInput #street2Input [(ngModel)]="manufacturerInfo.street2" class="manufacturers manufacturers-item-input"
            (keyup.enter)="updateStreet2()" (keyup.escape)="cancelStreet2Update()" (blur)="updateStreet2($event)" />
          <mat-icon matSuffix (mousedown)="clearStreet2InputField()">cancel</mat-icon>
        </mat-form-field>
      </div>
    </div>

    <!-- <div class="manufacturers-multi-item-row"> -->
      <div class="manufacturers-item-container">
        <div class="manufacturers-item-input-container">
          <mat-form-field appearance="outline" class="manufacturers-form-field">
            <mat-label>City</mat-label>
            <input matInput #cityInput [(ngModel)]="manufacturerInfo.city" class="manufacturers manufacturers-item-input"
            (keyup.enter)="updateCity()" (keyup.escape)="cancelCityUpdate()" (blur)="updateCity($event)" />
            <mat-icon matSuffix (mousedown)="clearCityInputField()">cancel</mat-icon>
          </mat-form-field>
        </div>
    </div>

    <div class="manufacturers-item-container">
      <div class="manufacturers-item-input-container">
        <mat-form-field class="manufacturers-form-field">
          <mat-label>State</mat-label>
          <mat-select [(value)]="manufacturerInfo.state" (keyup.enter)="updateState($event)" (keyup.escape)="cancelStateUpdate()" (blur)="updateState($event)">
            <ng-container  *ngFor="let s of states">
                <mat-option [value]="s.key" class="manufacturers-select-item">{{ s.value }}</mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
      </div>
    </div>
    
    <div class="manufacturers-item-container">
      <div class="manufacturers-item-input-container">
        <mat-form-field appearance="outline" class="manufacturers-form-field">
          <mat-label>Zip Code</mat-label>
          <input matInput #postalCodeInput [(ngModel)]="manufacturerInfo.postalCode" class="manufacturers manufacturers-item-input"
          (keyup.enter)="updatePostalCode($event)" (keyup.escape)="cancelPostalCodeUpdate()" (blur)="updatePostalCode($event)" />
          <mat-icon matSuffix (mousedown)="clearPostalCodeInputField()">cancel</mat-icon>
        </mat-form-field>
      </div>
    </div>
  <!-- </div> -->

    
  </div>
</ng-template>